'use strict';

// Profile Databag
define('profile_databag',['jquery.amd', 'databag', 'deviceInfo', 'underscore'], function profile_databag($, Databag, deviceInfo, _) {
  var profile = new Databag({name: 'nvtag'});
  
  function checkAllowListAndFetch() {
    $.jsonp({
      cache: !deviceInfo.ie,
      url: profile.databag_root + 'identity'
    }).then(function (id) {
      profile.allowlisted = true;
      if (id) {
        profile.set('id', id, { silent: true });
      }
    }, function () {
      profile.allowlisted = false;
      // this probably isn't required, but there is a race condition that we want to handle.
      $('.ngp-form .FastAction').remove();
    }).always(function () {
      profile.fetch({ prefill: true });
    });
  }

  profile.checkAllowListAndFetch = _.once(checkAllowListAndFetch);
  return profile;
});

